import { Injectable } from '@angular/core';
import { APISCockpit } from 'src/service/apis-cockpit';
import { InputItem } from '../../inputcommon/inputcommon.class';
import { InputContract } from '../inputmodels/inputcontract.model';

const API = '/api/construction-projects/v1/cockpit-inputContracts/';

@Injectable({ providedIn: 'root' })
export class InputContractService {

  inputcontract: InputContract = new InputContract();
  inputContracts: InputContract[] = [];

  constructor(private apiCockpit: APISCockpit) { }

  async GetInfoInput(itm: InputItem) {
    if (typeof (itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id;

      try
      {
        const itemResult = (await this.apiCockpit.getDataInfo(url));

        this.inputContracts = itemResult.items;
        if (this.inputContracts.length > 0) {
          this.inputcontract = this.inputContracts[0];
        }
        if(itemResult.errorList?.length > 0)
        {
          this.inputcontract.errorList = itemResult.errorList;
        }
      }
      catch { }
    }
    return this.inputcontract;
  }

  async GetInfoInputByTask(itm: InputItem) {
    if (typeof (itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id + '/bytask/' + itm.taskid;
      const itemResult = (await this.apiCockpit.getDataInfo(url));

      this.inputContracts = itemResult.items;
      if (this.inputContracts.length > 0) {
        this.inputcontract = this.inputContracts[0];
      }
      if(itemResult.errorList?.length > 0)
      {
        this.inputcontract.errorList = itemResult.errorList;
      }
    }
    return this.inputcontract;
  }

}
